// extracted by mini-css-extract-plugin
export default {"wrapper":"ir-z","response":"jr-z","error":"kr-z","disabled":"lr-z","buttons":"mr-z","feedbackQuestionSection":"nr-z","yesNoWrapper":"or-z"};